
<div class="container my-4">
  <div class="row">
    <div class="col">
      <div class="d-flex justify-content-center flex-nowrap">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Password Reset Email</h5>
            <p class="card-text">Kindly check your inbox and click on the link to reset your password.</p>
            <a class="link" [routerLink]="['/signin']">Go back to login</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


